export const raffleParkingStyles = {
	// Links, selected indicators and switches are black; action buttons stay red.
	primaryColor: '#1a1a19',
	header: {
		backgroundColor: '#ffffff',
		color: '#1a1a19',
	},
	sidebar: {
		backgroundColor: '#ffffff',
		color: '#1a1a19',
		'& #pca__sidebar-nav li:not(.sidebar-skeleton) a:not(.active)': {
			opacity: 1,
			'&:hover': { opacity: 1, textDecoration: 'underline' },
		},
	},
	button: {
		backgroundColor: '#c1171c',
		color: '#ffffff',
		border: '1px solid #c1171c',
		fontWeight: 600,
		'& .MuiBadge-badge': {
			backgroundColor: '#ffffff',
			color: '#1a1a19',
			border: '1px solid #1a1a19',
		},
		':hover': {
			backgroundColor: '#1a1a19',
			border: '1px solid #1a1a19',
			color: '#ffffff',
		},
	},
	title: {
		color: '#1a1a19',
	},
	tab: {
		backgroundColor: '#1a1a19',
		color: '#ffffff',
	},
	text: {
		color: '#1a1a19',
		buttonLoadingColor: '#ffffff',
	},
	table: {
		headerBackgroundColor: '#1a1a19',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Raffle Parking Platform',
	},
	logo: {
		small: {
			src: '/raffleParking/raffle-parking-icon.png',
			height: 42,
			width: 42,
		},
		large: {
			src: '/raffleParking/raffle-parking-logo-inline.png',
			height: 31,
			width: 135,
		},
	},
	monthlyCheckoutLogo: {
		small: {
			src: '/raffleParking/raffle-parking-icon.png',
			height: 45,
			width: 45,
		},
		large: {
			src: '/raffleParking/raffle-parking-logo-inline.png',
			height: 52,
			width: 227,
		},
	},
	favicon: {
		src: '/raffleParking/raffle-parking-icon.png',
	},
	socials: {},
	siteUrl: '',
	orgName: 'Raffle Parking',
};
